import { CUBE_AGGREGATE_INTERACTION } from '@/api/hcp/interaction/types';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { CubeQuery, GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { getDateRangeTimeDimension } from '@/utils/cube';
import { Filter } from '@cubejs-client/core';
import { EVENT_SOURCE_FILTER_LIMIT } from '../../filterDefaultLimits';

const LOCAL_SOURCE_FILTER_OPTIONS: GetOptionsQueryFunction = ({ sourceCube, dateRange }) => {
  const timeDimensions = getDateRangeTimeDimension({
    dateRange,
    dimension: `${CUBE_AGGREGATE_INTERACTION}.interaction_date`,
  });
  const query: CubeQuery = {
    dimensions: [`${sourceCube}.event_source_country`],
    limit: EVENT_SOURCE_FILTER_LIMIT,
    timeDimensions: [timeDimensions],
  };
  return query;
};

const localSourceCountryFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.localSourceCountryFilterLabel',
  sourceCube: CUBE_AGGREGATE_INTERACTION,
  defaultValue: [],
  type: 'multiselect',
  placeholder: 'global.filters.formControls.localSourceCountryFilterPlaceholder',
  searchable: true,
  clearable: true,
  getOptionsQuery: LOCAL_SOURCE_FILTER_OPTIONS,
  mapResult: mapDimensionToOption(`${CUBE_AGGREGATE_INTERACTION}.event_source_country`),
  applyFilter: (value): Filter | undefined => {
    if (Array.isArray(value) && value.every(filterValue => typeof filterValue === 'string')) {
      return {
        member: `${CUBE_AGGREGATE_INTERACTION}.event_source_country`,
        operator: 'equals',
        values: value,
      };
    }
  },
};

export default localSourceCountryFilter;
